// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Attachment Pickers Modal System (Ballots & Shorts) ─── */

.picker-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(4, 12, 10, 0.82);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
}

.picker-modal-container {
  background: linear-gradient(180deg, #0d1e1a 0%, #081512 100%);
  border: 1px solid rgba(72, 209, 204, 0.25);
  border-radius: 20px;
  width: 100%;
  max-width: 740px;
  height: 85vh;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.85), 0 0 35px rgba(72, 209, 204, 0.15);
  overflow: hidden;
  color: #f1f5f9;
  position: relative;
  z-index: 1000000;
}

.shorts-picker-container {
  max-width: 740px;
}

/* Header */
.picker-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(72, 209, 204, 0.12);
  background: rgba(13, 30, 26, 0.6);
}

.picker-header-title-box {
  display: flex;
  align-items: center;
  gap: 14px;
}

.picker-icon-badge {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ballot-badge {
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
}

.shorts-badge {
  background: rgba(45, 212, 191, 0.12);
  border: 1px solid rgba(45, 212, 191, 0.3);
}

.picker-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: -0.01em;
}

.picker-subtitle {
  font-size: 0.82rem;
  color: #94a3b8;
  margin: 2px 0 0 0;
}

.btn-picker-close {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-picker-close:hover {
  background: rgba(239, 68, 68, 0.18);
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
  transform: scale(1.05);
}

/* Controls: Search & Filter Tabs */
.picker-controls-row {
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 21, 18, 0.4);
}

.picker-search-wrapper {
  flex: 1 1;
  min-width: 220px;
  position: relative;
  display: flex;
  align-items: center;
}

.picker-search-icon {
  position: absolute;
  left: 12px;
  font-size: 19px !important;
  color: #64748b;
  pointer-events: none;
}

.picker-search-input {
  width: 100%;
  padding: 10px 36px 10px 38px;
  background: rgba(16, 34, 30, 0.7);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-radius: 10px;
  color: #fff;
  font-size: 0.88rem;
  outline: none;
  transition: all 0.2s ease;
}

.picker-search-input:focus {
  border-color: #48D1CC;
  background: rgba(16, 34, 30, 0.95);
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.15);
}

.picker-search-clear {
  position: absolute;
  right: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #94a3b8;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.picker-filter-tabs {
  display: flex;
  align-items: center;
  background: rgba(16, 34, 30, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}

.picker-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.picker-tab:hover {
  color: #fff;
}

.picker-tab.active {
  background: rgba(72, 209, 204, 0.18);
  color: #48D1CC;
  font-weight: 600;
  border: 1px solid rgba(72, 209, 204, 0.3);
}

/* Custom Styled Sort Dropdown */
.picker-sort-container {
  position: relative;
  display: flex;
  align-items: center;
}

.picker-sort-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: rgba(16, 34, 30, 0.7);
  border: 1px solid rgba(72, 209, 204, 0.22);
  border-radius: 10px;
  padding: 7px 12px 7px 10px;
  color: #e2e8f0;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  min-width: 145px;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.picker-sort-trigger:hover {
  background: rgba(16, 34, 30, 0.95);
  border-color: rgba(72, 209, 204, 0.45);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 10px rgba(72, 209, 204, 0.15);
}

.picker-sort-trigger.open {
  background: rgba(16, 34, 30, 1);
  border-color: #48D1CC;
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.2), 0 4px 16px rgba(0, 0, 0, 0.4);
}

.picker-sort-trigger-left {
  display: flex;
  align-items: center;
  gap: 7px;
}

.picker-sort-icon {
  font-size: 18px !important;
  color: #48D1CC;
  filter: drop-shadow(0 0 6px rgba(72, 209, 204, 0.4));
}

.picker-sort-label {
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.picker-sort-arrow {
  font-size: 18px !important;
  color: #94a3b8;
  transition: transform 0.2s ease, color 0.2s ease;
}

.picker-sort-trigger:hover .picker-sort-arrow,
.picker-sort-trigger.open .picker-sort-arrow {
  color: #48D1CC;
}

.picker-sort-arrow.rotated {
  transform: rotate(180deg);
}

/* Dropdown Menu Popup */
.picker-sort-menu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  width: 205px;
  background: linear-gradient(180deg, rgba(12, 28, 25, 0.98) 0%, rgba(6, 17, 15, 0.98) 100%);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(72, 209, 204, 0.3);
  border-radius: 12px;
  padding: 6px;
  box-shadow: 
    0 16px 40px rgba(0, 0, 0, 0.8),
    0 0 20px rgba(72, 209, 204, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  z-index: 1000;
  transform-origin: top right;
}

.picker-sort-menu-header {
  padding: 6px 10px 4px;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 4px;
}

.picker-sort-menu-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.picker-sort-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #cbd5e1;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all 0.18s ease;
}

.picker-sort-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.picker-sort-item-icon {
  font-size: 13px;
}

.picker-sort-item-text {
  letter-spacing: 0.01em;
}

.picker-sort-item:hover {
  background: rgba(72, 209, 204, 0.12);
  border-color: rgba(72, 209, 204, 0.25);
  color: #ffffff;
  transform: translateX(2px);
}

.picker-sort-item.selected {
  background: rgba(72, 209, 204, 0.18);
  border-color: rgba(72, 209, 204, 0.4);
  color: #48D1CC;
  font-weight: 700;
}

.picker-sort-check {
  font-size: 16px !important;
  color: #48D1CC;
  filter: drop-shadow(0 0 6px rgba(72, 209, 204, 0.6));
}

/* Items List & Loading / Empty states */
.picker-items-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.picker-loading-state,
.picker-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  text-align: center;
  color: #94a3b8;
}

.picker-empty-state h4 {
  font-size: 1rem;
  color: #e2e8f0;
  margin: 12px 0 4px 0;
}

.picker-empty-state p,
.picker-loading-state p {
  font-size: 0.85rem;
  margin: 4px 0 0 0;
}

/* Ballot Picker Cards */
.picker-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 18px;
  background: rgba(16, 34, 30, 0.45);
  border: 1px solid rgba(72, 209, 204, 0.12);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
}

.picker-card.ballot-picker-card {
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 0;
  overflow: hidden;
  flex-shrink: 0;
}

.picker-card-main-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 18px;
  width: 100%;
  box-sizing: border-box;
}

.picker-card:hover {
  background: rgba(16, 34, 30, 0.85);
  border-color: rgba(72, 209, 204, 0.35);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.picker-card.selected {
  background: rgba(72, 209, 204, 0.1);
  border-color: #48D1CC;
  box-shadow: 0 0 16px rgba(72, 209, 204, 0.15);
}

.picker-card.expanded {
  border-color: rgba(72, 209, 204, 0.35);
  background: rgba(16, 34, 30, 0.8);
}

/* Options dropdown toggle button */
.btn-picker-options-toggle {
  background: rgba(72, 209, 204, 0.08);
  border: 1px solid rgba(72, 209, 204, 0.25);
  color: #48D1CC;
  border-radius: 8px;
  padding: 3px 9px;
  font-size: 0.78rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-picker-options-toggle:hover,
.btn-picker-options-toggle.active {
  background: rgba(72, 209, 204, 0.22);
  border-color: #48D1CC;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(72, 209, 204, 0.2);
}

/* Dropdown Container */
.picker-card-options-dropdown {
  background: rgba(6, 17, 14, 0.85);
  border-top: 1px solid rgba(72, 209, 204, 0.12);
  overflow: hidden;
}

.picker-options-dropdown-inner {
  padding: 12px 18px 16px 54px;
}

.picker-options-dropdown-header {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.picker-options-total-badge {
  font-size: 0.7rem;
  color: #48D1CC;
  background: rgba(72, 209, 204, 0.12);
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid rgba(72, 209, 204, 0.25);
  font-weight: 600;
  text-transform: none;
}

.picker-options-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.picker-option-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(16, 34, 30, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.15s ease;
  position: relative;
  overflow: hidden;
}

.picker-option-row.picker-option-user-pick {
  border-color: rgba(72, 209, 204, 0.4);
  background: rgba(16, 34, 30, 0.95);
}

.picker-opt-progress-bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgba(72, 209, 204, 0.14);
  border-right: 2px solid rgba(72, 209, 204, 0.5);
  pointer-events: none;
  transition: width 0.3s ease;
  border-radius: 7px 0 0 7px;
  z-index: 1;
}

.picker-option-row:hover {
  background: rgba(16, 34, 30, 0.98);
  border-color: rgba(72, 209, 204, 0.3);
  transform: translateX(2px);
}

.picker-opt-letter-badge {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: rgba(72, 209, 204, 0.15);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48D1CC;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
  position: relative;
}

.picker-opt-text {
  font-size: 0.84rem;
  color: #e2e8f0;
  flex: 1 1;
  line-height: 1.35;
  z-index: 2;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.picker-opt-user-tag {
  font-size: 0.68rem;
  background: rgba(72, 209, 204, 0.2);
  border: 1px solid rgba(72, 209, 204, 0.4);
  color: #48D1CC;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 700;
}

.picker-opt-stats-box {
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}

.picker-opt-percent {
  font-size: 0.76rem;
  font-weight: 700;
  color: #48D1CC;
}

.picker-opt-votes-pill {
  font-size: 0.72rem;
  color: #94a3b8;
  background: rgba(0, 0, 0, 0.45);
  padding: 2px 7px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.picker-card-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.picker-card-content {
  flex: 1 1;
  min-width: 0;
}

.picker-card-header-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.picker-card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 480px;
}

.picker-pill {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: inline-flex;
  align-items: center;
}

.option-type-pill {
  background: rgba(72, 209, 204, 0.14);
  color: #48D1CC;
  border: 1px solid rgba(72, 209, 204, 0.25);
}

.sub-ballot-pill {
  background: rgba(168, 85, 247, 0.15);
  color: #c084fc;
  border: 1px solid rgba(168, 85, 247, 0.3);
}

.voted-status-pill {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.picker-card-desc {
  font-size: 0.82rem;
  color: #94a3b8;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.picker-creator-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.picker-creator-avatar {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(72, 209, 204, 0.3);
}

.picker-card-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.78rem;
  color: #64748b;
}

.picker-meta-item strong {
  color: #cbd5e1;
}

.picker-card-action {
  flex-shrink: 0;
}

.btn-picker-select {
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48D1CC;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-picker-select:hover {
  background: #48D1CC;
  color: #091714;
}

.btn-picker-select.selected {
  background: #48D1CC;
  color: #091714;
}

/* ─── Shorts Picker Grid Layout ─── */
.picker-shorts-grid {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 16px;
  align-items: stretch;
}

.grid-span-all {
  grid-column: 1 / -1;
}

.picker-short-card {
  background: rgba(16, 34, 30, 0.65);
  border: 1px solid rgba(45, 212, 191, 0.2);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  width: 100%;
  height: 330px;
  box-sizing: border-box;
}

.picker-short-card:hover {
  background: rgba(16, 34, 30, 0.9);
  border-color: rgba(45, 212, 191, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
}

.picker-short-card.selected {
  border-color: #2dd4bf;
  box-shadow: 0 0 20px rgba(45, 212, 191, 0.3);
}

.picker-short-media {
  position: relative;
  width: 100%;
  height: 240px;
  min-height: 240px;
  max-height: 240px;
  background: #06110f;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.picker-short-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.picker-short-card:hover .picker-short-img {
  transform: scale(1.04);
}

.picker-short-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #2dd4bf;
  background: linear-gradient(180deg, #10221E 0%, #06110f 100%);
  gap: 6px;
}

.picker-short-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  border: 2px solid rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 4;
  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.65);
}

.picker-short-play-btn:hover {
  transform: translate(-50%, -50%) scale(1.15);
  background: rgba(16, 34, 30, 0.95);
  border-color: #2dd4bf;
  box-shadow: 0 0 20px rgba(45, 212, 191, 0.4);
}

.picker-short-play-btn.playing {
  opacity: 0;
  background: rgba(16, 34, 30, 0.85);
  border-color: #2dd4bf;
}

.picker-short-card:hover .picker-short-play-btn.playing {
  opacity: 0.95;
  transform: translate(-50%, -50%) scale(1.05);
}

.picker-short-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
  z-index: 2;
}

.picker-short-linked-vote {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(9, 23, 20, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(72, 209, 204, 0.4);
  color: #48D1CC;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 7px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.picker-short-select-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.8));
  z-index: 2;
}

.picker-short-info {
  padding: 8px 12px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  background: rgba(10, 24, 21, 0.95);
  box-sizing: border-box;
  overflow: hidden;
}

.picker-short-text-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.picker-short-title {
  font-size: 0.86rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.picker-short-desc {
  font-size: 0.74rem;
  color: #94a3b8;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 1.1rem;
  line-height: 1.1rem;
}

.picker-short-author {
  font-size: 0.72rem;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 2px;
}

.picker-short-creator-name {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #94a3b8;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.picker-short-author-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(45, 212, 191, 0.3);
  flex-shrink: 0;
}

.picker-short-date {
  color: #475569;
  font-size: 0.7rem;
  flex-shrink: 0;
}

/* Custom scrollbars */
.picker-items-list::-webkit-scrollbar,
.picker-shorts-grid::-webkit-scrollbar {
  width: 6px;
}

.picker-items-list::-webkit-scrollbar-track,
.picker-shorts-grid::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.picker-items-list::-webkit-scrollbar-thumb,
.picker-shorts-grid::-webkit-scrollbar-thumb {
  background: rgba(72, 209, 204, 0.25);
  border-radius: 10px;
}

.picker-items-list::-webkit-scrollbar-thumb:hover,
.picker-shorts-grid::-webkit-scrollbar-thumb:hover {
  background: rgba(72, 209, 204, 0.45);
}

/* ─── Sticky Footer Action Toolbar ─── */
.picker-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: rgba(8, 21, 18, 0.9);
  border-top: 1px solid rgba(72, 209, 204, 0.15);
  gap: 16px;
  box-sizing: border-box;
}

.picker-footer-selection-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
}

.picker-selection-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
  color: #48D1CC;
  max-width: 100%;
}

.picker-selection-tag.short-tag {
  background: rgba(45, 212, 191, 0.12);
  border-color: rgba(45, 212, 191, 0.3);
  color: #2dd4bf;
}

.picker-selection-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
  font-weight: 600;
  color: #fff;
}

.btn-picker-clear-sel {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.btn-picker-clear-sel:hover {
  color: #f87171;
}

.picker-none-selected {
  font-size: 0.82rem;
  color: #64748b;
  font-style: italic;
}

.picker-footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.btn-picker-cancel {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #cbd5e1;
  padding: 8px 18px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-picker-cancel:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.btn-picker-confirm {
  background: linear-gradient(135deg, #48D1CC 0%, #20b2aa 100%);
  border: none;
  color: #091714;
  padding: 8px 22px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.3);
}

.btn-picker-confirm:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(72, 209, 204, 0.45);
  background: linear-gradient(135deg, #5fe3de 0%, #28c7be 100%);
}

.btn-picker-confirm:disabled {
  background: rgba(255, 255, 255, 0.08);
  color: #64748b;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 640px) {
  .picker-modal-container {
    max-height: 92vh;
  }
  .picker-modal-header {
    padding: 16px;
  }
  .picker-controls-row {
    padding: 12px 16px;
    gap: 10px;
  }
  .picker-search-wrapper {
    width: 100%;
    min-width: 100%;
  }
  .picker-filter-tabs,
  .picker-sort-container {
    flex: 1 1;
    min-width: 140px;
  }
  .picker-sort-trigger {
    width: 100%;
    justify-content: space-between;
  }
  .picker-sort-menu {
    width: 100%;
    right: 0;
    left: 0;
  }
  .picker-items-list,
  .picker-shorts-grid {
    padding: 12px 16px;
  }
  .picker-shorts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .picker-modal-footer {
    padding: 12px 16px;
    flex-direction: column;
    align-items: stretch;
  }
  .picker-footer-actions {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Communities/CommunityDetail/AttachmentPickers.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,oFAAoF;EACpF,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kDAAkD;EAClD,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,WAAW;EACX,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,0FAA0F;EAC1F,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ;;;0CAGwC;EACxC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,oDAAoD;AACtD;;AAEA,wCAAwC;AACxC;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,kDAAkD;EAClD,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,oCAAoC;EACpC,+CAA+C;EAC/C,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mDAAmD;EACnD,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6DAA6D;EAC7D,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,8CAA8C;EAC9C,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;;IAEE,SAAO;IACP,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,QAAQ;IACR,OAAO;EACT;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ─── Attachment Pickers Modal System (Ballots & Shorts) ─── */\n\n.picker-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(4, 12, 10, 0.82);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n}\n\n.picker-modal-container {\n  background: linear-gradient(180deg, #0d1e1a 0%, #081512 100%);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 740px;\n  height: 85vh;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.85), 0 0 35px rgba(72, 209, 204, 0.15);\n  overflow: hidden;\n  color: #f1f5f9;\n  position: relative;\n  z-index: 1000000;\n}\n\n.shorts-picker-container {\n  max-width: 740px;\n}\n\n/* Header */\n.picker-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(72, 209, 204, 0.12);\n  background: rgba(13, 30, 26, 0.6);\n}\n\n.picker-header-title-box {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.picker-icon-badge {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ballot-badge {\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n}\n\n.shorts-badge {\n  background: rgba(45, 212, 191, 0.12);\n  border: 1px solid rgba(45, 212, 191, 0.3);\n}\n\n.picker-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.picker-subtitle {\n  font-size: 0.82rem;\n  color: #94a3b8;\n  margin: 2px 0 0 0;\n}\n\n.btn-picker-close {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-picker-close:hover {\n  background: rgba(239, 68, 68, 0.18);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #f87171;\n  transform: scale(1.05);\n}\n\n/* Controls: Search & Filter Tabs */\n.picker-controls-row {\n  padding: 16px 24px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 21, 18, 0.4);\n}\n\n.picker-search-wrapper {\n  flex: 1;\n  min-width: 220px;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.picker-search-icon {\n  position: absolute;\n  left: 12px;\n  font-size: 19px !important;\n  color: #64748b;\n  pointer-events: none;\n}\n\n.picker-search-input {\n  width: 100%;\n  padding: 10px 36px 10px 38px;\n  background: rgba(16, 34, 30, 0.7);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-radius: 10px;\n  color: #fff;\n  font-size: 0.88rem;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.picker-search-input:focus {\n  border-color: #48D1CC;\n  background: rgba(16, 34, 30, 0.95);\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.15);\n}\n\n.picker-search-clear {\n  position: absolute;\n  right: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #94a3b8;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.picker-filter-tabs {\n  display: flex;\n  align-items: center;\n  background: rgba(16, 34, 30, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n}\n\n.picker-tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.picker-tab:hover {\n  color: #fff;\n}\n\n.picker-tab.active {\n  background: rgba(72, 209, 204, 0.18);\n  color: #48D1CC;\n  font-weight: 600;\n  border: 1px solid rgba(72, 209, 204, 0.3);\n}\n\n/* Custom Styled Sort Dropdown */\n.picker-sort-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.picker-sort-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: rgba(16, 34, 30, 0.7);\n  border: 1px solid rgba(72, 209, 204, 0.22);\n  border-radius: 10px;\n  padding: 7px 12px 7px 10px;\n  color: #e2e8f0;\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  outline: none;\n  min-width: 145px;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.picker-sort-trigger:hover {\n  background: rgba(16, 34, 30, 0.95);\n  border-color: rgba(72, 209, 204, 0.45);\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 10px rgba(72, 209, 204, 0.15);\n}\n\n.picker-sort-trigger.open {\n  background: rgba(16, 34, 30, 1);\n  border-color: #48D1CC;\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.2), 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.picker-sort-trigger-left {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.picker-sort-icon {\n  font-size: 18px !important;\n  color: #48D1CC;\n  filter: drop-shadow(0 0 6px rgba(72, 209, 204, 0.4));\n}\n\n.picker-sort-label {\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.picker-sort-arrow {\n  font-size: 18px !important;\n  color: #94a3b8;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.picker-sort-trigger:hover .picker-sort-arrow,\n.picker-sort-trigger.open .picker-sort-arrow {\n  color: #48D1CC;\n}\n\n.picker-sort-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Menu Popup */\n.picker-sort-menu {\n  position: absolute;\n  top: calc(100% + 7px);\n  right: 0;\n  width: 205px;\n  background: linear-gradient(180deg, rgba(12, 28, 25, 0.98) 0%, rgba(6, 17, 15, 0.98) 100%);\n  backdrop-filter: blur(24px) saturate(180%);\n  -webkit-backdrop-filter: blur(24px) saturate(180%);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  border-radius: 12px;\n  padding: 6px;\n  box-shadow: \n    0 16px 40px rgba(0, 0, 0, 0.8),\n    0 0 20px rgba(72, 209, 204, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  z-index: 1000;\n  transform-origin: top right;\n}\n\n.picker-sort-menu-header {\n  padding: 6px 10px 4px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  margin-bottom: 4px;\n}\n\n.picker-sort-menu-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.picker-sort-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 8px 10px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  color: #cbd5e1;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.18s ease;\n}\n\n.picker-sort-item-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.picker-sort-item-icon {\n  font-size: 13px;\n}\n\n.picker-sort-item-text {\n  letter-spacing: 0.01em;\n}\n\n.picker-sort-item:hover {\n  background: rgba(72, 209, 204, 0.12);\n  border-color: rgba(72, 209, 204, 0.25);\n  color: #ffffff;\n  transform: translateX(2px);\n}\n\n.picker-sort-item.selected {\n  background: rgba(72, 209, 204, 0.18);\n  border-color: rgba(72, 209, 204, 0.4);\n  color: #48D1CC;\n  font-weight: 700;\n}\n\n.picker-sort-check {\n  font-size: 16px !important;\n  color: #48D1CC;\n  filter: drop-shadow(0 0 6px rgba(72, 209, 204, 0.6));\n}\n\n/* Items List & Loading / Empty states */\n.picker-items-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.picker-loading-state,\n.picker-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 20px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.picker-empty-state h4 {\n  font-size: 1rem;\n  color: #e2e8f0;\n  margin: 12px 0 4px 0;\n}\n\n.picker-empty-state p,\n.picker-loading-state p {\n  font-size: 0.85rem;\n  margin: 4px 0 0 0;\n}\n\n/* Ballot Picker Cards */\n.picker-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 18px;\n  background: rgba(16, 34, 30, 0.45);\n  border: 1px solid rgba(72, 209, 204, 0.12);\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.picker-card.ballot-picker-card {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.picker-card-main-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 18px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.picker-card:hover {\n  background: rgba(16, 34, 30, 0.85);\n  border-color: rgba(72, 209, 204, 0.35);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.picker-card.selected {\n  background: rgba(72, 209, 204, 0.1);\n  border-color: #48D1CC;\n  box-shadow: 0 0 16px rgba(72, 209, 204, 0.15);\n}\n\n.picker-card.expanded {\n  border-color: rgba(72, 209, 204, 0.35);\n  background: rgba(16, 34, 30, 0.8);\n}\n\n/* Options dropdown toggle button */\n.btn-picker-options-toggle {\n  background: rgba(72, 209, 204, 0.08);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  color: #48D1CC;\n  border-radius: 8px;\n  padding: 3px 9px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-picker-options-toggle:hover,\n.btn-picker-options-toggle.active {\n  background: rgba(72, 209, 204, 0.22);\n  border-color: #48D1CC;\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(72, 209, 204, 0.2);\n}\n\n/* Dropdown Container */\n.picker-card-options-dropdown {\n  background: rgba(6, 17, 14, 0.85);\n  border-top: 1px solid rgba(72, 209, 204, 0.12);\n  overflow: hidden;\n}\n\n.picker-options-dropdown-inner {\n  padding: 12px 18px 16px 54px;\n}\n\n.picker-options-dropdown-header {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.picker-options-total-badge {\n  font-size: 0.7rem;\n  color: #48D1CC;\n  background: rgba(72, 209, 204, 0.12);\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  font-weight: 600;\n  text-transform: none;\n}\n\n.picker-options-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.picker-option-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(16, 34, 30, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 8px 12px;\n  transition: all 0.15s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.picker-option-row.picker-option-user-pick {\n  border-color: rgba(72, 209, 204, 0.4);\n  background: rgba(16, 34, 30, 0.95);\n}\n\n.picker-opt-progress-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(72, 209, 204, 0.14);\n  border-right: 2px solid rgba(72, 209, 204, 0.5);\n  pointer-events: none;\n  transition: width 0.3s ease;\n  border-radius: 7px 0 0 7px;\n  z-index: 1;\n}\n\n.picker-option-row:hover {\n  background: rgba(16, 34, 30, 0.98);\n  border-color: rgba(72, 209, 204, 0.3);\n  transform: translateX(2px);\n}\n\n.picker-opt-letter-badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  background: rgba(72, 209, 204, 0.15);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48D1CC;\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  z-index: 2;\n  position: relative;\n}\n\n.picker-opt-text {\n  font-size: 0.84rem;\n  color: #e2e8f0;\n  flex: 1;\n  line-height: 1.35;\n  z-index: 2;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.picker-opt-user-tag {\n  font-size: 0.68rem;\n  background: rgba(72, 209, 204, 0.2);\n  border: 1px solid rgba(72, 209, 204, 0.4);\n  color: #48D1CC;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-weight: 700;\n}\n\n.picker-opt-stats-box {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 2;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.picker-opt-percent {\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: #48D1CC;\n}\n\n.picker-opt-votes-pill {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  background: rgba(0, 0, 0, 0.45);\n  padding: 2px 7px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.picker-card-radio {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.picker-card-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.picker-card-header-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.picker-card-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 480px;\n}\n\n.picker-pill {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  display: inline-flex;\n  align-items: center;\n}\n\n.option-type-pill {\n  background: rgba(72, 209, 204, 0.14);\n  color: #48D1CC;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n}\n\n.sub-ballot-pill {\n  background: rgba(168, 85, 247, 0.15);\n  color: #c084fc;\n  border: 1px solid rgba(168, 85, 247, 0.3);\n}\n\n.voted-status-pill {\n  background: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.picker-card-desc {\n  font-size: 0.82rem;\n  color: #94a3b8;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.picker-creator-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.picker-creator-avatar {\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid rgba(72, 209, 204, 0.3);\n}\n\n.picker-card-meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.picker-meta-item strong {\n  color: #cbd5e1;\n}\n\n.picker-card-action {\n  flex-shrink: 0;\n}\n\n.btn-picker-select {\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48D1CC;\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-picker-select:hover {\n  background: #48D1CC;\n  color: #091714;\n}\n\n.btn-picker-select.selected {\n  background: #48D1CC;\n  color: #091714;\n}\n\n/* ─── Shorts Picker Grid Layout ─── */\n.picker-shorts-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 24px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n\n.grid-span-all {\n  grid-column: 1 / -1;\n}\n\n.picker-short-card {\n  background: rgba(16, 34, 30, 0.65);\n  border: 1px solid rgba(45, 212, 191, 0.2);\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  width: 100%;\n  height: 330px;\n  box-sizing: border-box;\n}\n\n.picker-short-card:hover {\n  background: rgba(16, 34, 30, 0.9);\n  border-color: rgba(45, 212, 191, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n}\n\n.picker-short-card.selected {\n  border-color: #2dd4bf;\n  box-shadow: 0 0 20px rgba(45, 212, 191, 0.3);\n}\n\n.picker-short-media {\n  position: relative;\n  width: 100%;\n  height: 240px;\n  min-height: 240px;\n  max-height: 240px;\n  background: #06110f;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.picker-short-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.picker-short-card:hover .picker-short-img {\n  transform: scale(1.04);\n}\n\n.picker-short-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #2dd4bf;\n  background: linear-gradient(180deg, #10221E 0%, #06110f 100%);\n  gap: 6px;\n}\n\n.picker-short-play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.65);\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 4;\n  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.65);\n}\n\n.picker-short-play-btn:hover {\n  transform: translate(-50%, -50%) scale(1.15);\n  background: rgba(16, 34, 30, 0.95);\n  border-color: #2dd4bf;\n  box-shadow: 0 0 20px rgba(45, 212, 191, 0.4);\n}\n\n.picker-short-play-btn.playing {\n  opacity: 0;\n  background: rgba(16, 34, 30, 0.85);\n  border-color: #2dd4bf;\n}\n\n.picker-short-card:hover .picker-short-play-btn.playing {\n  opacity: 0.95;\n  transform: translate(-50%, -50%) scale(1.05);\n}\n\n.picker-short-duration {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 3px 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  z-index: 2;\n}\n\n.picker-short-linked-vote {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: rgba(9, 23, 20, 0.88);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(72, 209, 204, 0.4);\n  color: #48D1CC;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 3px 7px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  z-index: 2;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.picker-short-select-indicator {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.8));\n  z-index: 2;\n}\n\n.picker-short-info {\n  padding: 8px 12px 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1 1 auto;\n  background: rgba(10, 24, 21, 0.95);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.picker-short-text-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.picker-short-title {\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.25;\n}\n\n.picker-short-desc {\n  font-size: 0.74rem;\n  color: #94a3b8;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 1.1rem;\n  line-height: 1.1rem;\n}\n\n.picker-short-author {\n  font-size: 0.72rem;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 2px;\n}\n\n.picker-short-creator-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #94a3b8;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px;\n}\n\n.picker-short-author-avatar {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid rgba(45, 212, 191, 0.3);\n  flex-shrink: 0;\n}\n\n.picker-short-date {\n  color: #475569;\n  font-size: 0.7rem;\n  flex-shrink: 0;\n}\n\n/* Custom scrollbars */\n.picker-items-list::-webkit-scrollbar,\n.picker-shorts-grid::-webkit-scrollbar {\n  width: 6px;\n}\n\n.picker-items-list::-webkit-scrollbar-track,\n.picker-shorts-grid::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.picker-items-list::-webkit-scrollbar-thumb,\n.picker-shorts-grid::-webkit-scrollbar-thumb {\n  background: rgba(72, 209, 204, 0.25);\n  border-radius: 10px;\n}\n\n.picker-items-list::-webkit-scrollbar-thumb:hover,\n.picker-shorts-grid::-webkit-scrollbar-thumb:hover {\n  background: rgba(72, 209, 204, 0.45);\n}\n\n/* ─── Sticky Footer Action Toolbar ─── */\n.picker-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 24px;\n  background: rgba(8, 21, 18, 0.9);\n  border-top: 1px solid rgba(72, 209, 204, 0.15);\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n.picker-footer-selection-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.picker-selection-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  padding: 5px 12px;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  color: #48D1CC;\n  max-width: 100%;\n}\n\n.picker-selection-tag.short-tag {\n  background: rgba(45, 212, 191, 0.12);\n  border-color: rgba(45, 212, 191, 0.3);\n  color: #2dd4bf;\n}\n\n.picker-selection-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 240px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.btn-picker-clear-sel {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.btn-picker-clear-sel:hover {\n  color: #f87171;\n}\n\n.picker-none-selected {\n  font-size: 0.82rem;\n  color: #64748b;\n  font-style: italic;\n}\n\n.picker-footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.btn-picker-cancel {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #cbd5e1;\n  padding: 8px 18px;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-picker-cancel:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.btn-picker-confirm {\n  background: linear-gradient(135deg, #48D1CC 0%, #20b2aa 100%);\n  border: none;\n  color: #091714;\n  padding: 8px 22px;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.3);\n}\n\n.btn-picker-confirm:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(72, 209, 204, 0.45);\n  background: linear-gradient(135deg, #5fe3de 0%, #28c7be 100%);\n}\n\n.btn-picker-confirm:disabled {\n  background: rgba(255, 255, 255, 0.08);\n  color: #64748b;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n@media (max-width: 640px) {\n  .picker-modal-container {\n    max-height: 92vh;\n  }\n  .picker-modal-header {\n    padding: 16px;\n  }\n  .picker-controls-row {\n    padding: 12px 16px;\n    gap: 10px;\n  }\n  .picker-search-wrapper {\n    width: 100%;\n    min-width: 100%;\n  }\n  .picker-filter-tabs,\n  .picker-sort-container {\n    flex: 1;\n    min-width: 140px;\n  }\n  .picker-sort-trigger {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .picker-sort-menu {\n    width: 100%;\n    right: 0;\n    left: 0;\n  }\n  .picker-items-list,\n  .picker-shorts-grid {\n    padding: 12px 16px;\n  }\n  .picker-shorts-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .picker-modal-footer {\n    padding: 12px 16px;\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .picker-footer-actions {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
